export default function DoctorsApprovalIcon(props) {
	return (
		<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.00665 0C10.5695 0 13.5106 2.7324 13.9555 6.2685L15.9261 9.4536C16.0557 9.6633 16.0295 9.9756 15.7291 10.1088L14.0133 10.863V13.5C14.0133 14.4945 13.2294 15.3 12.2616 15.3H10.5109L10.51 18H2.62749V14.6754C2.62749 13.6134 2.24563 12.6081 1.53796 11.7009C0.575421 10.4679 0 8.9028 0 7.2C0 3.2238 3.13723 0 7.00665 0ZM7.00665 4.5C6.52319 4.5 6.13082 4.9032 6.13082 5.4V6.2991L5.25499 6.3C4.77153 6.3 4.37916 6.7032 4.37916 7.2C4.37916 7.6968 4.77153 8.1 5.25499 8.1L6.13082 8.0991V9C6.13082 9.4968 6.52319 9.9 7.00665 9.9C7.49011 9.9 7.88248 9.4968 7.88248 9V8.1H8.75832C9.24178 8.1 9.63415 7.6968 9.63415 7.2C9.63415 6.7032 9.24178 6.3 8.75832 6.3H7.88248V5.4C7.88248 4.9032 7.49011 4.5 7.00665 4.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}
